import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { MailListQueryParams } from "../models";

export abstract class MailListApi {
  static async get<T>({
    startIndex = 0,
    pageSize = 20,
    extraParams = {},
    responseSchema,
  }: MailListQueryParams<T>) {
    const response = GbApiRequestService.post(
      "userSearch",
      {
        startIndex,
        pageSize,
        params: {
          isReact: true,
          ...extraParams,
        },
        subType: "LetterSearchParams",
      },
      {
        headers: {
          "Content-Type": "text/plain",
        },
      },
    );

    const validatedResponse = await withSchemaValidation(
      response,
      responseSchema,
    );
    return validatedResponse;
  }
}
